module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Cambiar C&oacute;digo\" ng-click=\"$ctrl.verRegistro()\">\n  <i class=\"fa fa-cog\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/convenio/button.html
// module id = 713
// module chunks = 0